import { AbstractWebStorage } from './WebStorage';

export class SessionStorage<T> extends AbstractWebStorage<T> {
  constructor() {
    super(sessionStorage);
  }
}
